<pbc-filter-preset
  [filter]="archiv.preset$ | async"
  [filters]="archiv.presets$ | async"
  [name]="archiv.search$ | async"
  (select)="archiv.setFilter($event)"
  (save)="archiv.writeFilter($event)"
  (delete)="archiv.deleteFilter($event)"
></pbc-filter-preset>
